import $ from 'jquery';
import ClipboardJS from 'clipboard';
import customerInfo from '../../controls/customerinfo';
import miniCart from './../productclasspage/shared/minicart';
import page from '../../smartpak/page';
import {parseQueryString} from '../../smartpak/url';
import recentlyViewedProducts from '../../smartpak/recentlyviewedproducts';
import wizard from './wizard';
import events from '../checkout/cart/events';
import {antiForgeryPost} from '../../utils/fetch';
import messenger from '../shared/messenger';

var wishlist = {
    triggerCopyEvent: function () {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'gaTriggerEvent',
                gaEventCategory: 'share',
                gaEventAction: 'interaction',
                gaEventLabel: 'copy link'
            });
        }
    },
    _setShareLink: function () {
        $('#copyURL').on('click', function (e) {
            $(e.target).select();
        });
        $('#showURL').on(
            'click',
            function (e) {
                e.preventDefault();
                var $urlHold = $('#urlHolder');

                $urlHold[$urlHold.css('display') === 'none' ? 'slideDown' : 'slideUp']('fast');

                this.triggerCopyEvent();
            }.bind(this)
        );
    },
    _initCopy: function () {
        return new ClipboardJS('#copyButton');
    },
    _inactiveDialog: function (path) {
        $('body').append('<div id="promptInactive" class="jsHide"></div>');

        var $modal = $('#promptInactive'),
            modalWidth = '500px',
            url = '/apparel-tack-equipment-and-supplies-2039pc',
            dialogOptions = {
                title: 'Inactive Item',
                modal: true,
                resizable: false,
                width: modalWidth,
                close: function () {
                    document.location.href = path;
                },
                buttons: {
                    'Continue Shopping': function (modal) {
                        smartPak.page.redirectToUrl(url);
                        modal.close();
                    }
                }
            };

        if (page.isMobile()) {
            modalWidth = '300px';
        }

        smartPak.ui.modal(
            $modal.html("<div>We're sorry, but this item is no longer available.</div>").get(0),
            dialogOptions
        );
    },
    _handleRowRemoval: function () {
        if (!this._hasItemRows()) {
            this._showEmptyWishListMessage();
        }
    },
    _showEmptyWishListMessage: function () {
        $('#emptyList').removeClass('jsHide').addClass('grid-layout');
    },
    _hasItemRows: function () {
        return $('.wishDash').length > 0;
    },
    _showMiniCart: function (reorderItemResponse) {
        miniCart.show(reorderItemResponse.View);
        this._updateCartItemCount();
        smartPak.cdProfileCookie.refreshCookieData();
    },
    _updateCartItemCount: function () {
        customerInfo.refreshCartItemCount();
    },
    _initToast: function () {
        const toast = messenger.init();
        const content = 'Wishlist link copied to clipboard';
        toast.add({
            type: 'confirm',
            content,
            immediate: true
        });
    },
    _shareLinkHandler: function () {
        $('#copyButton').on('click', () => this._initToast());
    },
    _addUpdateWishListItemToCartHandler: function () {
        $('.removeWishListItem')
            .off('click')
            .on('click', event => this._handleRemoveClick(event));
        $('.btnAddWishListItemToCart')
            .off('click')
            .on('click', event => this._handleAddToCartClick(event));
    },
    _handleAddToCartClick: function (event) {
        event.preventDefault();

        const {
            action,
            price,
            name,
            productClassId,
            itemNumber,
            productId: id,
            quantity,
            isAutoship: isAutoShip,
            brand,
            primaryCategory: childReportingCategory,
            parentCategory: parentReportingCategory,
            isPrivateLabel,
            isSmartpak: isSmartPak
        } = event.target.dataset;

        const row = hiddenRowByTarget(event.target, () => this._handleRowRemoval());

        post(action)
            .then(response => {
                if (!response.inactive && response.redirectUrl) {
                    location.href = response.redirectUrl;
                    return;
                }

                if (response.inactive) {
                    this._inactiveDialog(location.pathname);
                    return;
                }

                if (response.Status !== 'SUCCESS') {
                    row.restore();
                    return;
                }

                row.remove();

                events.addCartItem({
                    isAutoShip,
                    brand,
                    childReportingCategory,
                    itemNumber: +itemNumber,
                    productClassId: +productClassId,
                    name,
                    parentReportingCategory,
                    isPrivateLabel,
                    isSmartPak,
                    id: +id,
                    price: parseFloat(price.replace('$', '')),
                    quantity: +quantity
                });

                if (page.isMobile()) {
                    location.href = '/cart';
                    return;
                }

                if (response.NextAction === 'SHOW_MINI_CART') {
                    this._showMiniCart(response);
                }
            })
            .catch(() => row.restore());
    },
    _handleRemoveClick: function (event) {
        event.preventDefault();
        const {action} = event.target.dataset;
        const row = hiddenRowByTarget(event.target, () => this._handleRowRemoval());

        post(action)
            .then(response => {
                if (response.Status !== 'SUCCESS') {
                    row.restore();
                    return;
                }
                row.remove();
            })
            .catch(() => {
                row.restore();
            });
    },
    _reOrgTable: function () {
        //move 'Call Us' text to bottom:
        var callText = $('#WishlistOuter h3 span').text().replace('? ', '?<br />'),
            $callH3 = $('<h3 id="bottomH3">' + callText + '</h3>');
        $callH3.appendTo('#WishlistOuter');
        $('#WishlistOuter h3 span').remove();
    },
    _parseQueryString: parseQueryString,
    _hideCTA: function (search) {
        var wishlistId = this._parseQueryString(search).wishlistId,
            isMobile = page.isMobile();

        if (wishlistId) {
            if (!isMobile) {
                $('.wishWidth').addClass('sharedWishWidth');
            }

            $('.starWidth').addClass('sharedStarWidth');
            $('.wishBtnWidth').hide();
        }
    },
    init: function () {
        this._shareLinkHandler();
        this._addUpdateWishListItemToCartHandler();
        this._setShareLink();
        this._initCopy();
        this._hideCTA(location.search);
        recentlyViewedProducts.loadBvReviewStars('.wishlistReviewStars');

        if (wizard && document.getElementById('wizard-container')) {
            wizard.init();
        }

        if ('matchMedia' in window && matchMedia('only screen and (max-width: 480px)').matches) {
            this._reOrgTable();
        }
    }
};

function hiddenRowByTarget($target, onRemoval) {
    const HIDE_CLASS = 'jsHide';
    const $row = $target.closest('.wishDash');

    $row.classList.add(HIDE_CLASS);

    return {
        restore: () => {
            $row.classList.remove(HIDE_CLASS);
        },
        remove: () => {
            $row.remove();

            if (onRemoval) {
                onRemoval();
            }
        }
    };
}

function post(url) {
    return antiForgeryPost(url).then(response => response.json());
}

export default wishlist;
